require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-photo-video-social-media-photography-bundle.json") })
        }
      }, "path---services-photo-video-social-media-photography-bundle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-photo-video-social-media-photography-bundle!./.cache/json/services-photo-video-social-media-photography-bundle.json
// module id = 764
// module chunks = 231608221292675